export default __webpack_public_path__ + "static/media/txt1_sp.9830a445.png";